import BlogGridView from "../../../commonComponents/blogGridView";

const Blog2GridRightContainer = () => {
  return <BlogGridView side="right" gridSize={2} />;
};

export default Blog2GridRightContainer;
